import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { npsApiRef } from './api';
import { NpsClient } from './api/NpsClient';
import { rootRouteRef } from './routes';

export const npsPlugin = createPlugin({
  id: 'nps',
  apis: [
    createApiFactory({
      api: npsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({ discoveryApi, fetchApi }) {
        return new NpsClient({ discoveryApi, fetchApi });
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const NpsPage = npsPlugin.provide(
  createRoutableExtension({
    name: 'NpsPage',
    component: () =>
      import('./components/NpsDashboard').then(m => m.NpsDashboard),
    mountPoint: rootRouteRef,
  }),
);
